/**
 * GCLID Capture für Luxurywoods.de
 * Liest gclid/gbraid/wbraid aus der URL, speichert sie 90 Tage im Cookie
 * und hängt sie beim ersten Cart-Kontakt als Cart Attributes an.
 * Cart Attributes werden von Shopify automatisch zu Order Note Attributes,
 * wenn der Checkout abgeschlossen wird.
 */
(function() {
  'use strict';

  function getParam(name) {
    var match = window.location.search.match(
      new RegExp('[?&]' + name + '=([^&]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';expires=' + d.toUTCString() +
      ';path=/;SameSite=Lax;Secure';
  }

  function getCookie(name) {
    var v = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return v ? decodeURIComponent(v.pop()) : null;
  }

  // 1. Neue Click-IDs aus URL in Cookie speichern (90 Tage = Google-Ads-Lookback)
  var freshGclid = getParam('gclid');
  if (freshGclid) setCookie('lxry_gclid', freshGclid, 90);

  var freshGbraid = getParam('gbraid');
  if (freshGbraid) setCookie('lxry_gbraid', freshGbraid, 90);

  var freshWbraid = getParam('wbraid');
  if (freshWbraid) setCookie('lxry_wbraid', freshWbraid, 90);

  // Zeitstempel des ersten Klicks festhalten (für Attribution-Analyse)
  if (freshGclid || freshGbraid || freshWbraid) {
    setCookie('lxry_click_ts', new Date().toISOString(), 90);
    setCookie('lxry_landing_page', window.location.pathname, 90);
  }

  // 2. Gespeicherte Click-IDs an Shopify Cart als Attribute hängen
  var storedGclid = getCookie('lxry_gclid');
  var storedGbraid = getCookie('lxry_gbraid');
  var storedWbraid = getCookie('lxry_wbraid');

  if (storedGclid || storedGbraid || storedWbraid) {
    var attributes = {};
    if (storedGclid) attributes['gclid'] = storedGclid;
    if (storedGbraid) attributes['gbraid'] = storedGbraid;
    if (storedWbraid) attributes['wbraid'] = storedWbraid;

    var clickTs = getCookie('lxry_click_ts');
    if (clickTs) attributes['gclid_click_ts'] = clickTs;

    var landing = getCookie('lxry_landing_page');
    if (landing) attributes['gclid_landing_page'] = landing;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function(err) {
      // Still silent fail – Tracking darf User-Experience niemals blockieren
      if (window.console && console.warn) {
        console.warn('[lxry-gclid] Cart update failed:', err);
      }
    });
  }
})();
